import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 overflow-auto" }
const _hoisted_2 = { class: "flex flex-row justify-end mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "modal_cek_kendala",
    buttonId: "btn_close_modal_cek_kendala",
    class: "dialog-check-issue",
    modelValue: _ctx.openDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialog = $event)),
    title: "Cek kendala",
    persistent: "",
    titleSize: "16",
    closeIcon: "x-gray-24",
    onReset: _ctx.cancelPopup,
    textColor: "text-gray-lp-300"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          label: "No. kendala/STT/shipment id",
          class: "w-full",
          fontSize: "14"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LpInput, {
              id: "text_input_cek_kendala",
              class: "w-full",
              onChange: _ctx.onChangeSttNumber,
              modelValue: _ctx.sttNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNumber = $event)),
              iconLeft: "ics_o_search",
              placeholder: "Masukkan nomor kendala/STT/shipment id",
              maxLength: 50
            }, null, 8, ["onChange", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_LpButton, {
            id: "btn_form_modal_cek_kendala",
            onClick: _ctx.onCheckIssue,
            customClass: "px-8 py-2",
            title: "Cek sekarang",
            textColor: "white",
            disabled: _ctx.isCheckDisable
          }, null, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onReset"]))
}